
import { notification, Button } from 'ant-design-vue';
import { h } from 'vue';
import { updatePushMessage } from "@/request/view/pushMessage";
import router from '@/router/index';
import store from '@/store/index';

export const useNotification = (options) => {
    const { message, description, onClick, onClose } = options;
    const key = `open${Date.now()}`;
    notification.open({
        message,
        description,
        btn: h(
            Button,
            {
                type: 'primary',
                size: 'small',
                onClick,
            },
            '查看',
        ),
        key,
    });
};

export const useNotice = (record) => {
    const parseReocrd = JSON.parse(`${record}`);
    const { query, content, route, id } = parseReocrd;

    const key = `open${Date.now()}`;
    notification.open({
        message: "提示",
        description: content,
        btn: h(
            Button,
            {
                type: 'primary',
                size: 'small',
                onClick: () => {
                    updatePushMessage({ id, type: 1, });
                    router.replace({ path: route, query: JSON.parse(query) });
                    const unReadNum = store.state.unReadNum;
                    store.commit("SET_UNREADNUM", unReadNum - 1);
                    notification.close(key)
                },
            },
            '查看',
        ),
        key,
    });
};
